import { AppSettingsService } from './app-settings/app-settings.service';
import { ApiService } from './api/api.service';
import { ApiInterceptorInterceptor } from './../interceptor/api-interceptor.interceptor';
// import { ReportingService } from './reporting.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { NavBarItem } from './../Classes/NavBarItem';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class NavServiceService {

  selectedPage: string;
  selectedReporting: string = '';
  private stockdataServices = new BehaviorSubject<any>(null);
  private emitChangeTitle = new Subject<string>();
  titleChangeEmitted = this.emitChangeTitle.asObservable();

  private title$ = new BehaviorSubject<any>(null);
  titleSub = this.title$.asObservable();

  emitNavEnd = new Subject<void>();
  navEndEmitted = this.emitNavEnd.asObservable();

  // navBarItems2: NavBarItem[] = [
  //   new NavBarItem("Dashboard", "Dashboard", "dashboard", "", "/assets/v3/icon/navigation/nav-dashboard.svg",null),
  //   // new NavBarItem("", "Dashboard", "dashboard", "", "/assets/playground_assets/dashboard.svg",
  //   //   [
  //   //     new NavBarItem("Sales Dashboard", "Sales", "sales-db", "", "", null),
  //   //   ]),

  //   new NavBarItem("Store", "Store", "store", "", "/assets/v3/icon/navigation/nav-company.svg",
  //     [
  //       new NavBarItem("Store Setup", "Setup", "store-setup", "", "", null),
  //       new NavBarItem("Store Location", "Location", "store-zra", "", "", null),
  //       new NavBarItem("Store Group", "Group", "store-group", "", "", null)
  //     ]),
  //   new NavBarItem("", "Stock", "stock", "", "/assets/v3/icon/navigation/nav-stock.svg",
  //     [
  //       new NavBarItem("Stock Item", "Item", "stock-item", "", "", null),
  //       new NavBarItem("Build of Materials", "Build of Materials", "stock-bom", "", "", null),
  //       new NavBarItem("Stock Category", "Category", "stock-category", "", "", null),
  //       new NavBarItem("Stock Group", "Group", "stock-gd", "", "", null),
  //       new NavBarItem("Stock Department", "Department", "stock-department", "", "", null),
  //       // new NavBarItem("Stock Measurement", "Measurement", "stock-measurement", "", "", null),
  //       new NavBarItem("Stock Brand", "Brand", "stock-brand", "", "", null),
  //       new NavBarItem("Stock Settings", "Settings", "stock-settings", "", "", null),
  //     ]),
  //   new NavBarItem("", "Condiment", "condiment", "", "/assets/v3/icon/navigation/nav-condiment.svg",
  //     [
  //       new NavBarItem("Condiment Group", "Group", "group", "", "", null),
  //       new NavBarItem("Condiment Item", "Item", "list", "", "", null),

  //     ]),
  //   new NavBarItem("", "POS", "pos", "", "/assets/v3/icon/navigation/nav-pos.svg",
  //     [
  //       new NavBarItem("POS Shift", "Shift", "shift", "", "", null),
  //       new NavBarItem("POS Payment", "Payment", "payment", "", "", null),
  //       new NavBarItem("POS Tax", "Tax", "tax", "", "", null),
  //       new NavBarItem("POS Money Note", "Money Note", "money-note", "", "", null),
  //       new NavBarItem("POS Discount", "Discount", "discount", "", "", null),
  //     ]),
  //   new NavBarItem("", "E-Menu", "e-menu", "", "/assets/v3/icon/navigation/nav-emenu.svg",
  //     [
  //       new NavBarItem("Menu", "Menu", "menu", "", "", null),
  //       // new NavBarItem("Promotion", "Promotion", "promotion", "", "", null),
  //       new NavBarItem("E-Menu Setting", "Settings", "settings", "", "", null),
  //       new NavBarItem("E-Menu Activity Log", "Activity Log", "log", "", "", null),
  //     ]),
  //   // new NavBarItem("", "Voucher Hub", "voucher-hub", "", "/assets/v3/icon/navigation/nav-vouchers.svg",
  //   //   [
  //   //     new NavBarItem("Voucher Hub", "Create Campaign", "create-voucher", "", "", null),
  //   //     new NavBarItem("Voucher Dashboard", "Dashboard", "campaign", "", "", null),
  //   //   ]),
  //   new NavBarItem("", "Employee", "security-level", "", "/assets/v3/icon/navigation/nav-employee.svg",
  //     [
  //       new NavBarItem("User", "User", "user", "", "", null),
  //       new NavBarItem("Role", "Role", "user-group", "", "", null),
  //       new NavBarItem("Employee Details", "Details", "employee-details", "", "", null),
  //       new NavBarItem("Employee Class", "Class", "employee-class", "", "", null),
  //       new NavBarItem("Employee Group", "Group", "employee-group", "", "", null),
  //     ]),
  //   new NavBarItem("", "Customer", "customer","", "/assets/v3/icon/navigation/nav-customer.svg",
  //     [
  //       new NavBarItem("Customer Details", "Details", "details", "", "", null),
  //       new NavBarItem("Customer Class", "Class", "class", "", "", null),
  //       new NavBarItem("Customer Group", "Group", "cust-group", "", "", null),
  //       new NavBarItem("Discount Type", "Discount Type", "discount-type", "", "", null),
  //       new NavBarItem("Customer Closing", "Closing", "closing", "", "", null),
  //     ]
  //   ),
  //   // new NavBarItem("", "Agent", "agent", "", "/assets/v3/icon/navigation/nav-person.svg", 
  //   //   [
  //   //     new NavBarItem("Agent List", "Details", "agent-list", "", "", null),
  //   //     new NavBarItem("Agent Group", "Group", "agent-group", "", "", null),
  //   //   ]
  //   // ),
  //   // new NavBarItem("", "Personnel", "personnel", "", "/assets/v3/icon/navigation/nav-employee.svg",
  //   // [
  //   //   new NavBarItem("Agent Group", "Agent Group", "agent-group", "", "", null),
  //   //   new NavBarItem("Agent", "Agent", "agent", "", "", null)
  //   // ]),
  //   // new NavBarItem("", "Preferences", "preferences", "", "/assets/v3/icon/navigation/nav-preference.svg",
  //   //   [
  //   //     new NavBarItem("Price Shift", "Price Shift", "price-shift", "", "", null),
  //   //     new NavBarItem("Price Level", "Price Level", "price-level", "", "", null),
  //   //     // new NavBarItem("Cost Level", "Cost Level", "cost-level", "", "", null),
  //   //   ]),
  //   new NavBarItem("", "Inventory", "inventory", "", "/assets/v3/icon/navigation/nav-inventory.svg",
  //   [
  //     new NavBarItem("Inventory Transaction", "Transaction", "transaction", "", "", null),
  //     new NavBarItem("Production", "Production", "production", "", "", null),
  //     new NavBarItem("Stock Take List", "Stock Take", "stocktake", "", "", null), 
  //     new NavBarItem("Stock Enquiry Report", "Stock Enquiry", "stockenquiryreport", "", "", null),
  //     new NavBarItem("Production Enquiry Report", "Production Enquiry", "productionenquiry", "", "", null),
  //     new NavBarItem("Inventory Settings", "Settings", "inventory-settings", "", "", null),
  //     // new NavBarItem("Stock Out List", "Stock Out", "stock-out", "", "", null),
  //     // new NavBarItem("Quantity Adjustment Note", "Qty Adjustment", "qty-adj", "", "", null),
  //     // new NavBarItem("Cost Adjustment Note", "Cost Adjustment", "cost-adj", "", "", null),
  //   ]),
  //   new NavBarItem("", "Supplier", "supplier", "", "/assets/v3/icon/navigation/nav-supplier.svg",
  //   [
  //     new NavBarItem("Supplier Transactions", "Transaction", "supplier-transactions", "", "", null),
  //     new NavBarItem("Supplier Details", "Details", "supplier-details", "", "", null),
  //     new NavBarItem("Supplier Class", "Class", "supplier-class", "", "", null),
  //     new NavBarItem("Supplier Group", "Group", "supplier-group", "", "", null),
  //     new NavBarItem("Supplier Settings", "Settings", "supplier-settings", "", "", null),
  //     // new NavBarItem("Supplier Enquiry", "Supplier Enquiry", "supplier-enquiry-report", "", "", null),
  //   ]),
  //   // new NavBarItem("", "Kitchen Printing", "kitchen-printing", "", "/assets/v3/icon/navigation/nav-printer.svg",
  //   //   [
  //   //     new NavBarItem("Queue", "Queue", "queue", "", "", null),
  //   //     new NavBarItem("Spooler & Printer", "Spooler & Printer", "spooler-printer", "", "", null),
  //   //   ]),
  //   // new NavBarItem("", "Miscellaneous", "miscellaneous", "", "/assets/v3/icon/navigation/nav-report.svg",
  //   //   [
  //   //     new NavBarItem("Reason", "Reason", "reason", "", "", null),
  //   //     new NavBarItem("Currency", "Currency", "currency", "", "", null),
  //   //   ]),
  //   //new NavBarItem("Reports", "Reports", "reports", "", "/assets/v3/icon/navigation/nav-report.svg", null),
  //   new NavBarItem("", "Reports", "", "", "/assets/v3/icon/navigation/nav-report.svg",
  //   [
  //     new NavBarItem("", "Operation Reports", "reports", "", "",
  //     [
  //       new NavBarItem("Hourly Sales Report", "Hourly Sales", "hoursales", "", "", null),
  //       new NavBarItem("Tax Transaction Report", "Tax Transaction", "taxTransaction", "", "", null),
  //       new NavBarItem("Category Sales Report", "Category Sales", "categorySales", "", "", null),
  //       new NavBarItem("Department Sales Report", "Department Sales", "departmentSales", "", "", null),
  //       new NavBarItem("Group Sales Report", "Group Sales", "groupSales", "", "", null),
  //       new NavBarItem("Item Sales Report", "Item Sales", "skuSales", "", "", null),
  //       // new NavBarItem("Transaction Sales Report", "Transaction Sales", "transactionSales", "", "", null),
  //       // new NavBarItem("Transaction Void Report", "Transaction Void", "transactionvoid", "", "", null),
  //       new NavBarItem("Price Level Shift Report", "Price Level Shift", "pricelevelshift", "", "", null),
  //       new NavBarItem("Sales Remark Report", "Sales Remark", "salesremark", "", "", null),
  //       new NavBarItem("Sold Item Analysis Report", "Sold Item Analysis", "solditemanalysis", "", "", null),
  //       new NavBarItem("Operator Collection Report", "Operator Collection", "operatorcollection", "", "", null),
  //       // new NavBarItem("Vendor Voucher Report", "Vendor Voucher", "vendorvoucher", "", "", null),
  //       // new NavBarItem("Store Voucher Report", "Store Voucher", "storevoucher", "", "", null),
  //       new NavBarItem("Receipt Analysis Report", "Receipt Analysis", "receiptanalysis", "", "", null),
  //       new NavBarItem("Inactive Stock Report", "Inactive Stock", "inactivestock", "", "", null),
  //       new NavBarItem("Average Sales Summary Report", "Average Sales Summary", "averagesalessummary", "", "", null),         
  //       new NavBarItem("Attendance Report", "Time Attendance", "attendance-report", "", "", null),         
  //     ]),
  //     new NavBarItem("", "Transaction Reports", "reports", "", "",
  //     [
  //       new NavBarItem("Transaction Details Report", "Transaction Details", "transactionDetails", "", "", null),
  //       new NavBarItem("Payment Type Report", "Payment Type", "paymentType", "", "", null),
  //       new NavBarItem("Terminal Collection Report", "Terminal Collection", "terminalCollection", "", "", null)     
  //     ]),

  //   ]),
  //   new NavBarItem("", "Settings", "settings", "", "/assets/v3/icon/navigation/nav-setting.svg", 
  //     [
  //       new NavBarItem("Reset", "Reset", "reset", "", "", null),

  //     ]
  //   ),
  // ];

  // reportingNavBarItems: { [key: string]: NavBarItem[] } =
  //   {
  //     'sales-report':
  //       [
  //         new NavBarItem("", "Item Sales Report", "item", "", "", null),
  //         new NavBarItem("", "Group Sales Report", "group", "", "", null),
  //         new NavBarItem("", "Department Sales Report", "department", "", "", null),
  //         new NavBarItem("", "Sub-Department Sales Report", "sub-department", "", "", null),
  //         new NavBarItem("", "Category Sales Report", "category", "", "", null),
  //         /*new NavBarItem("", "Supplier Sales Report", "supplier", "", null),*/
  //         /*new NavBarItem("", "Set Menu Sales Report", "set-menu", "", null),
  //         new NavBarItem("", "Item Report by Price Level/Shift", "item-price-shift", "", null),
  //         /*new NavBarItem("", "Sales Remark Report", "sales-remark", "", null),*/
  //         new NavBarItem("", "Item Shift Sales Report", "item-shift", "", "", null)
  //       ],
  //     'sales-analysis-report':
  //       [
  //         new NavBarItem("", "Item P&L Report", "item-pnl", "", "", null),
  //         new NavBarItem("", "Group P&L Report", "group-pnl", "", "", null),
  //         new NavBarItem("", "Department P&L Report", "department-pnl", "", "", null),
  //         new NavBarItem("", "Sub-Department P&L Report", "sub-department-pnl", "", "", null),
  //         new NavBarItem("", "Category P&L Report", "category-pnl", "", "", null),
  //         /*new NavBarItem("", "Supplier P&L Report", "supplier-pnl", "", null),*/
  //         new NavBarItem("", "Best Seller Report", "best-seller", "", "", null),
  //         new NavBarItem("", "Month End Sales Report", "month-end-sales", "", "", null),
  //         new NavBarItem("", "Year End Sales", "year-end-sales", "", "", null)
  //       ],
  // };

  navBarItems: NavBarItem[] = [
    new NavBarItem("Dashboard", "Dashboard", "dashboard", "", "/assets/v3/icon/navigation/nav-dashboard.svg",null),
    
    new NavBarItem("Report", "Report", "", "", "/assets/v3/icon/navigation/nav-report.svg",
      [
        new NavBarItem("", "Operation Reports", "o-reports", "", "", 
        [
          new NavBarItem("Hourly Sales Report", "Hourly Sales", "hoursales", "", "", null),
          new NavBarItem("Tax Transaction Report", "Tax Transaction", "taxTransaction", "", "", null),
          new NavBarItem("Category Sales Report", "Category Sales", "categorySales", "", "", null),
          new NavBarItem("Department Sales Report", "Department Sales", "departmentSales", "", "", null),
          new NavBarItem("Group Sales Report", "Group Sales", "groupSales", "", "", null),
          new NavBarItem("Item Sales Report", "Item Sales", "skuSales", "", "", null),
          new NavBarItem("Price Level Shift Report", "Price Level Shift", "pricelevelshift", "", "", null),
          new NavBarItem("Sales Remark Report", "Sales Remark", "salesremark", "", "", null),
          new NavBarItem("Sold Item Analysis Report", "Sold Item Analysis", "solditemanalysis", "", "", null),
          new NavBarItem("Operator Collection Report", "Operator Collection", "operatorcollection", "", "", null),
          new NavBarItem("Receipt Analysis Report", "Receipt Analysis", "receiptanalysis", "", "", null),
          new NavBarItem("Inactive Stock Report", "Inactive Stock", "inactivestock", "", "", null),
          new NavBarItem("Average Sales Summary Report", "Average Sales Summary", "averagesalessummary", "", "", null),         
          new NavBarItem("Attendance Report", "Time Attendance", "attendance-report", "", "", null),         
          new NavBarItem("Stock Enquiry Report", "Stock Enquiry", "stockenquiryreport", "", "", null),         
        ]),
        new NavBarItem("", "Transaction Reports", "t-reports", "", "", 
        [
          new NavBarItem("Transaction Details Report", "Transaction Details", "transactionDetails", "", "", null),
          new NavBarItem("Payment Type Report", "Payment Type", "paymentType", "", "", null),
          new NavBarItem("Terminal Collection Report", "Terminal Collection", "terminalCollection", "", "", null)     
        ]),
      ]),
    new NavBarItem("Store", "Store", "store", "", "/assets/v3/icon/navigation/nav-company.svg",
      [
        new NavBarItem("Store Structure", "Structure", "store-structure", "", "", null),
        new NavBarItem("Store Classification", "Classification", "store-group", "", "", null),
      ]),
    new NavBarItem("Stock", "Stock", "stock", "", "/assets/v3/icon/navigation/nav-stock.svg",
      [
        new NavBarItem("Stock Item", "Item", "stock-item", "", "", null),
        // new NavBarItem("Build of Materials", "Build of Materials", "stock-bom", "", "", null),
        new NavBarItem("Stock Classification", "Classification", "stock-gd", "", "", null),
      ]),
    new NavBarItem("Condiment", "Condiment", "condiment", "", "/assets/v3/icon/navigation/nav-condiment.svg",
      [
        new NavBarItem("Condiment Group", "Group", "group", "", "", null),
        new NavBarItem("Condiment Item", "Item", "list", "", "", null),
      ]),
    new NavBarItem("POS", "POS", "pos", "", "/assets/v3/icon/navigation/nav-pos.svg",
      [
        new NavBarItem("POS Shift", "Shift", "shift", "", "", null),
        new NavBarItem("POS Payment", "Payment", "payment", "", "", null),
        new NavBarItem("POS Tax", "POS Tax", "tax", "", "", null),
        new NavBarItem("POS Money Note", "Money Note", "money-note", "", "", null),
        new NavBarItem("POS Discount", "Discount", "discount", "", "", null),
      ]),
    new NavBarItem("User Management", "User Management", "security-level", "", "/assets/v3/icon/navigation/nav-employee.svg",
      [
        new NavBarItem("User Profile", "User Profile", "user", "", "", null),
        new NavBarItem("Role Management", "Role Management", "user-group", "", "", null),
        new NavBarItem("User Classification", "Classification", "employee-group", "", "", null)
      ]),
    new NavBarItem("Customer", "Customer", "customer", "", "/assets/v3/icon/navigation/nav-customer.svg",
      [
        new NavBarItem("Customer Details", "Details", "details", "", "", null),
        new NavBarItem("Customer Discount Type", "Discount Type", "discount-type", "", "", null),
        new NavBarItem("Customer Closing", "Closing", "closing", "", "", null),
        new NavBarItem("Customer Classification", "Classification", "cust-group", "", "", null),
      ]),
    new NavBarItem("Inventory", "Inventory", "inventory", "", "/assets/v3/icon/navigation/nav-inventory.svg",
      [
        new NavBarItem("Inventory Transaction", "Transaction", "transaction", "", "", null),
        // new NavBarItem("Inventory Production", "Production", "production", "", "", null),
        // new NavBarItem("Stock Take", "Inventory Stock Take", "stocktake-preparation", "", "", null),
      ]),
    // new NavBarItem("Supplier", "Supplier", "supplier", "", "/assets/v3/icon/navigation/nav-supplier.svg",
    //   [
    //     new NavBarItem("Supplier Transaction", "Transaction", "supplier-transactions", "", "", null),
    //     new NavBarItem("Supplier Details", "Details", "supplier-details", "", "", null),
    //     new NavBarItem("Supplier Classification", "Classification", "supplier-group", "", "", null),
    //   ]),
    new NavBarItem("Settings", "Settings", "settings", "", "/assets/v3/icon/navigation/nav-setting.svg",
      [
        new NavBarItem("Stock Settings", "Stock", "stock-settings", "", "", null),
        // new NavBarItem("E-Menu Settings", "E-Menu", "emenu-menu", "", "", null),
        new NavBarItem("Preferences Settings", "Preferences", "price-shift", "", "", null),
        new NavBarItem("Inventory Settings", "Inventory", "inventory-approval-settings", "", "", null),
        // new NavBarItem("Supplier Settings", "Supplier", "supplier-approval-settings", "", "", null),
        new NavBarItem("Kitchen Printing Settings", "Kitchen", "queue", "", "", null),
        new NavBarItem("Miscellaneous Settings", "Miscellaneous", "reason", "", "", null),
        // new NavBarItem("POS Settings", "POS", "", "", "", null),
      ]),
    new NavBarItem("Housekeeping", "Housekeeping", "housekeeping", "", "/assets/v3/icon/navigation/nav-housekeeping.svg",
      [
        new NavBarItem("Housekeeping", "Housekeeping", "reset", "", "", null)
      ]),
  ]

  addMode: boolean;
  data: any;
  additionalParam: any;
  previousData: any = null;

  activeSideBar: any = '';
  activeSubMenu: any = '';


  constructor(private router: Router, private apiService: ApiService, private appSettingsService: AppSettingsService,private cookieService: CookieService, private permission: PermissionService) {
    // constructor(private router: Router, private reportingService: ReportingService, private apiService: ApiService, private appSettingsService: AppSettingsService,private cookieService: CookieService) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.CheckSelectedPage(router.url);
      this.updateActiveMenu(router.url);
      // this.emitChangeTitle.next(this.GetTitle(this.navBarItems));
      this.GetTitle(this.navBarItems, router.url);
      if (router.url.split('/').pop() != 'login') {
        this.emitNavEnd.next();
      }
    });

  }

  ngOnInit(){
    
  }

  async getMenu(): Promise<NavBarItem[]>{
    let allMenu = this.navBarItems;
    await this.permission.GetUserPermission();
    if (this.permission.canAccessDashboard() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'dashboard');
    }
    if (this.permission.canAccessStore() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'store');
    }
    if (this.permission.canAccessStock() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'stock');
    }
    if (this.permission.canAccessCondiment() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'condiment');
    }
    if (this.permission.canAccessPos() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'pos');
    }
    if (this.permission.canAccessEmployee() === false && this.permission.canAccessAgent() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'security-level');
    }
    if (this.permission.canAccessPreferences() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'preferences');
    }
    if (this.permission.canAccessKitchenPrinting() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'kitchen-printing');
    }
    if (this.permission.canAccessMiscellaneous() === false){
      
      allMenu = allMenu.filter(x => x.routerLink != 'miscellaneous');
    }
    if (this.permission.canAccessReports() === false){
      allMenu = allMenu.filter(x => x.title != 'Report');
    }
    
    if (this.permission.canAccessCustomer() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'customer');
    }
    // if (this.permission.canAccessAgent() === false){
    //   allMenu = allMenu.filter(x => x.routerLink != 'agent');
    // }
    if (this.permission.canAccessInventory() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'inventory');
    }
    if (this.permission.canAccessSupplier() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'supplier');
    }
    if (this.permission.canAccessEmenu() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'e-menu');
    }
    if (this.permission.canAccessSettings() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'settings');
    }
    if (this.permission.canAccessHousekeeping() === false){
      allMenu = allMenu.filter(x => x.routerLink != 'housekeeping');
    }

    return allMenu;
  }


  CheckSelectedPage(url: string) {
    let urlArr = url.split('/');
    let selectedPage = urlArr.pop();

    this.selectedPage = url.includes('reporting') ? (selectedPage.includes('report') ? selectedPage : urlArr.pop()) :
      (selectedPage.endsWith('-country') ? selectedPage.replace('-country', '') :
        selectedPage.endsWith('-state') ? selectedPage.replace('-state', '') :
          selectedPage.endsWith('-city') ? selectedPage.replace('-city', '') :
          selectedPage.endsWith('-preparation') ? selectedPage.replace('-preparation', '') :
          selectedPage.endsWith('-entry') ? selectedPage.replace('-entry', '') :
          selectedPage.endsWith('-uom-manage') ? selectedPage.replace('-uom-manage', '') :
            selectedPage.endsWith('-manage') ? selectedPage.replace('-manage', '') : selectedPage);


    // if (url.startsWith('/management/agent')){
    //   this.selectedPage = 'agent';
      
    // }
    
    if (this.selectedPage.includes('report')) {
      this.selectedReporting = url.split('/').pop();
      // this.reportingService.selectedReport = this.selectedReporting;
    }
    else {
      this.selectedReporting = '';
      // this.reportingService.selectedReport = this.selectedReporting;
    }
  }

  public NavigateRoute(parentRoute: string, childRoute: string) {
    let nagivateRoute: string = parentRoute == undefined ? this.router.url + "-" + childRoute :
      (parentRoute.length ? "/management/" + parentRoute + "/" + childRoute : "/management/" + childRoute);

    this.router.navigateByUrl(nagivateRoute);
  }

  public NavigateParentRoute() {
    let newUrlArr = this.router.url.split('/');
    let lastUrl = newUrlArr.pop();
    lastUrl =
      lastUrl.endsWith('-country') ? lastUrl.replace('-country', '') :
        lastUrl.endsWith('-state') ? lastUrl.replace('-state', '') :
          lastUrl.endsWith('-city') ? lastUrl.replace('-city', '') :
            // lastUrl.endsWith('-entry') ? lastUrl.replace('-entry', '-take') :
            lastUrl.endsWith('-preparation') ? lastUrl.replace('-preparation', '') :
            lastUrl.endsWith('-entry') ? lastUrl.replace('-entry', '') :
            lastUrl.endsWith('-uom-manage') ? lastUrl.replace('-uom-manage', '') :
              lastUrl.endsWith('-manage') ? lastUrl.replace('-manage', '') : '';

    this.router.navigateByUrl(newUrlArr.join('/') + (lastUrl.length == 0 ? + '' : '/' + lastUrl));
  }

  public NavigateReportingRoute(childRoute: string) {
    let lastUrl = this.router.url.split('/').pop();

    this.router.navigateByUrl(this.router.url.replace(lastUrl, childRoute));
  }

  GetTitle(navBarItems: NavBarItem[], url: string): string {
    let urlArr = url.split('/');
    let selectedPage = urlArr.pop();

    // console.log(selectedPage)
    if ((navBarItems != null && navBarItems != undefined) && navBarItems.length > 0 &&
      (selectedPage != null && selectedPage != undefined) && selectedPage != '') {

        let getItems = navBarItems.flatMap( (main: any) => main?.subMenus).find( (nav: any) => nav?.routerLink == selectedPage);
        if (getItems != null){
          this.title$.next(getItems?.topTitle ?? '');
          return getItems?.topTitle ?? '';
        }
    }

    return '';
  }

  GetReportingList(): any {
    // return this.reportingNavBarItems[this.selectedPage];
    return [];
  }

  LogOut() {
    if (ApiInterceptorInterceptor.token.length == 0 || !ApiInterceptorInterceptor.token) {
      ApiInterceptorInterceptor.token = null;
      ApiInterceptorInterceptor.refresh_token = null;
      // localStorage.removeItem('access_token');
      // localStorage.removeItem('refresh_token');
      // localStorage.removeItem('userName');
      // localStorage.removeItem('crmURL');
      // localStorage.removeItem('userID');
      // localStorage.removeItem('Email');
      // localStorage.removeItem('domain');
      // sessionStorage.removeItem('stockDataNeeded');
      // sessionStorage.removeItem('addMode');
      // sessionStorage.removeItem('data');
      localStorage.clear();
      // localStorage.clearItems('user');
      this.permission.clearPermission();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      history.pushState(null, '', location.href);
      window.onpopstate = function () {
        history.go(1);
      };
    }
    else {
      this.apiService.Logout().subscribe(() => {
        this.router.navigate(['/login'], { replaceUrl: true });
        ApiInterceptorInterceptor.token = null;
        ApiInterceptorInterceptor.refresh_token = null;
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('userName');
        localStorage.removeItem('crmURL');
        localStorage.removeItem('userID');
        localStorage.removeItem('Email');
        localStorage.removeItem('domain');
        localStorage.removeItem('user');
        sessionStorage.removeItem('stockDataNeeded');
        sessionStorage.removeItem('addMode');
        sessionStorage.removeItem('data');
        this.permission.clearPermission();
        history.pushState(null, '', location.href);
        window.onpopstate = function () {
          history.go(1);
        };
        // this.appSettingsService.DeleteApiSettings();    
      });
    }
  }

  async navigateToLandPage(){
    await this.permission.GetUserPermission();

    // console.log(this.permission.canAccessDashboard());

    if (this.permission.canAccessDashboard()){
      return this.router.navigate(['/management/dashboard'], { replaceUrl: true, });
    }
    if (this.permission.canAccessStore()){
      return this.router.navigate(['/management/store'], { replaceUrl: true, });
    }
    if (this.permission.canAccessStock()){
      return this.router.navigate(['/management/stock'], { replaceUrl: true, });
    }
    if (this.permission.canAccessCondiment()){
      return this.router.navigate(['/management/condiment'], { replaceUrl: true, });
    }
    if (this.permission.canAccessPos()){
      return this.router.navigate(['/management/pos'], { replaceUrl: true, });
    }
    if (this.permission.canAccessEmployee()){
      return this.router.navigate(['/management/security-level'], { replaceUrl: true, });
    }
    if (this.permission.canAccessCustomer()){
      return this.router.navigate(['/management/customer'], { replaceUrl: true, });
    }
    if (this.permission.canAccessPreferences()){
      return this.router.navigate(['/management/preferences'], { replaceUrl: true, });
    }
    if (this.permission.canAccessKitchenPrinting()){
      return this.router.navigate(['/management/kitchen-printing'], { replaceUrl: true, });
    }
    if (this.permission.canAccessMiscellaneous()){
      return this.router.navigate(['/management/miscellaneous'], { replaceUrl: true, });
    }
    if (this.permission.canAccessReports()){
      return this.router.navigate(['/management/reports'], { replaceUrl: true, });
    }
    if (this.permission.canAccessSettings()){
      return this.router.navigate(['/management/settings'], { replaceUrl: true, });
    }

    return this.router.navigate(['/management/unauthorized'], { replaceUrl: true, });
  }


  updateTitle(title: string){
    this.title$.next(title ?? '');
  }

  updateActiveMenu(url: string){
    let urlArr = url.split('/');
    let selectedPage = urlArr.pop();
    
    let storeClass = ['store-group','store-group-manage', 'store-country', 'store-state', 'store-city'];
    let stockClass = ['stock-department'];
    let userManagement = ['employee-details', 'agent-list'];
    let userClass = ['employee-class', 'agent-group'];
    let customerClass = ['class'];
    let inventoryStockTake = ['stocktake-entry'];
    let supplierClass = ['supplier-class']; 
    let invSettings = ['inventory-uom-settings'];
    let prefSettings = ['price-level'];
    let kitchenSettings = ['spooler-printer'];
    let miscSettings = ['currency'];
    let emenuSettings = ['emenu-settings', 'emenu-log' ];
    let oReports = ['hoursales','taxTransaction','categorySales','departmentSales','groupSales','skuSales','pricelevelshift','salesremark','solditemanalysis','operatorcollection','receiptanalysis','inactivestock','averagesalessummary','attendance-report'];
    let tReports = ['transactionDetails','paymentType','terminalCollection'];

    this.activeSubMenu = selectedPage;
    let removeManage = selectedPage.replace('-manage', '');
    this.activeSideBar = storeClass.includes(removeManage) ? 'store-group' : removeManage;
    this.activeSideBar = stockClass.includes(removeManage) ? 'stock-gd' : this.activeSideBar;
    this.activeSideBar = userManagement.includes(removeManage) ? 'user' : this.activeSideBar;
    this.activeSideBar = userClass.includes(removeManage) ? 'employee-group' : this.activeSideBar;
    this.activeSideBar = customerClass.includes(removeManage) ? 'cust-group' : this.activeSideBar;
    this.activeSideBar = inventoryStockTake.includes(removeManage) ? 'stocktake-preparation' : this.activeSideBar;
    this.activeSideBar = supplierClass.includes(removeManage) ? 'supplier-group' : this.activeSideBar;
    this.activeSideBar = invSettings.includes(removeManage) ? 'inventory-approval-settings' : this.activeSideBar;
    this.activeSideBar = prefSettings.includes(removeManage) ? 'price-shift' : this.activeSideBar;
    this.activeSideBar = kitchenSettings.includes(removeManage) ? 'queue' : this.activeSideBar;
    this.activeSideBar = miscSettings.includes(removeManage) ? 'reason' : this.activeSideBar;
    this.activeSideBar = emenuSettings.includes(removeManage) ? 'emenu-menu' : this.activeSideBar;
    this.activeSideBar = oReports.includes(removeManage) ? 'o-reports' : this.activeSideBar;
    this.activeSideBar = tReports.includes(removeManage) ? 't-reports' : this.activeSideBar;

    let getItems = this.navBarItems.flatMap( (main: any) => main?.subMenus).find( (nav: any) => nav?.routerLink == this.activeSideBar);
    if (getItems != null){
      this.title$.next(getItems?.topTitle ?? '');
    }
  }
}
